import { FieldErrors } from "react-hook-form";
import type { UserDefinedGroup, UserDefinedValueSubmit } from "@/types/domain";

export const getFieldErrorMessage = (errors: FieldErrors<any>, key: string): string | undefined => {
  const msg = errors[key]?.message;
  return typeof msg === "string" ? msg : undefined;
};

/**
 * Collects user-defined field values from react-hook-form values, normalising
 * Boolean fields from RHF's native boolean to the "1"/"0" strings the API expects.
 */
export const collectUserDefinedValues = (
  groups: UserDefinedGroup[] | null | undefined,
  values: Record<string, unknown>
): UserDefinedValueSubmit[] => {
  const result: UserDefinedValueSubmit[] = [];
  groups?.forEach((group) => {
    group.items.forEach((item) => {
      // Disabled controls can still contribute default Boolean values to RHF.
      // Read-only values must stay out of a create request to avoid changing them.
      if (item.isReadOnly) {
        return;
      }

      const raw = values[`ud_${item.itemId}`];
      // AsyncSelectField yields { value, label } for large lookups; extract the string value
      const rawStr = typeof raw === 'object' && raw !== null && 'value' in (raw as object)
        ? (raw as { value: string }).value
        : (raw as string) ?? '';
      const val = item.format === "Boolean"
        ? (raw === true ? "1" : raw === false ? "0" : rawStr)
        : rawStr;
      if (item.format === "Boolean" || val !== "") {
        result.push({ itemId: item.itemId, value: val });
      }
    });
  });
  return result;
};